'use client';

import { useState } from 'react';
import { postAPICall } from '@/utils/network';
import { DateTime } from 'luxon';
// Define the type for a comment
interface Comment {
    name: string;
    createdAt: string;
    comment: string;
}

// Function to get relative time
const getRelativeTime = (createdAt: string) => {
    const now = DateTime.now();
    const past = DateTime.fromISO(createdAt);
    const diff = now.diff(past, ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']).toObject();

    if (diff.years && diff.years > 0) return `${Math.floor(diff.years)} year${diff.years > 1 ? 's' : ''} ago`;
    if (diff.months && diff.months > 0) return `${Math.floor(diff.months)} month${diff.months > 1 ? 's' : ''} ago`;
    if (diff.weeks && diff.weeks > 0) return `${Math.floor(diff.weeks)} week${diff.weeks > 1 ? 's' : ''} ago`;
    if (diff.days && diff.days > 0) return `${Math.floor(diff.days)} day${diff.days > 1 ? 's' : ''} ago`;
    if (diff.hours && diff.hours > 0) return `${Math.floor(diff.hours)} hour${diff.hours > 1 ? 's' : ''} ago`;
    if (diff.minutes && diff.minutes > 0) return `${Math.floor(diff.minutes)} minute${diff.minutes > 1 ? 's' : ''} ago`;
    if (diff.seconds && diff.seconds > 0) return `${Math.floor(diff.seconds)} second${diff.seconds > 1 ? 's' : ''} ago`;
    return 'just now';
};
export default function CommentsSection({ commentData, editorialId }: any) {
    // console.log(commentData);
    const [comment, setComment] = useState({
        name: '',
        editorialId: editorialId,
        comment: '',
        publish: 'false',
    });

    const addComment = async () => {
        // Added async
        try {
            const response = await postAPICall(`/comments`, comment, 'application/json');
            if (response && response.status === 200) {
                setComment({
                    name: '',
                    editorialId: editorialId,
                    comment: '',
                    publish: 'false',
                });
            }
        } catch (error) {
            console.error('Error adding comment:', error);
        }
    };

    return (
        <div>
            {' '}
            <div className="max-w-full mx-auto mt-10 border-t-[1px] border-solid border-[#222222] px-4 sm:px-2">
                <h2 className="text-2xl font-thin mb-4 mt-6">Comments</h2>
                <div className="flex flex-col gap-2 mb-4 sm:flex-row sm:gap-2">
                    <input
                        type="text"
                        className="w-full sm:w-[30%] border px-4 py-3 text-md bg-gray-100 rounded-md"
                        placeholder="Your name"
                        value={comment.name}
                        onChange={(e) => setComment({ ...comment, name: e.target.value })}
                    />
                    <input
                        type="text"
                        className="w-full sm:w-[60%] border px-4 py-3 text-md bg-gray-100 rounded-md"
                        placeholder="Write your comment here..."
                        value={comment.comment}
                        onChange={(e) => setComment({ ...comment, comment: e.target.value })}
                    />
                    <button
                        className="w-full sm:w-[10%] bg-[#059AFF] text-white px-4 py-2 shadow-md hover:bg-[#059AFF] rounded-md"
                        onClick={addComment}
                    >
                        Publish
                    </button>
                </div>
            </div>
            <div className="border-t-[1px] border-b-[1px] border-solid border-[#222222]">
                {commentData.slice(0, 3).map((c: Comment, index: number) => (
                    // <div
                    //     key={index}
                    //     className="flex items-start gap-3 mb-3 mt-4 sm:gap-2 sm:mb-2 sm:mt-2 border-2 border-solid"
                    // >
                    //     <div className="w-[10%] lg:w-[5%] flex items-center justify-center border-2 border-solid">
                    //         <div className="w-10 h-10 lg:w-10 lg:h-10 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full mx-auto"></div>
                    //     </div>

                    //     <div className="border-2 border-solid p-1">
                    //         <p className="font-semibold text-sm">
                    //             {c.name}{' '}
                    //             <span className="text-gray-500 text-xs ml-1">{getRelativeTime(c.createdAt)}</span>
                    //         </p>
                    //         <p className="text-sm text-gray-700">{c.comment}</p>
                    //     </div>
                    // </div>
                    <div key={index} className="flex items-center mb-3 mt-4 sm:gap-2 sm:mb-2 sm:mt-2">
                        {/* Avatar Wrapper */}
                        <div className="w-[15%] sm:w-[12%] md:w-[10%] lg:w-[5%] flex items-center justify-center h-full">
                            <div className="w-10 h-10 sm:w-8 sm:h-8 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full"></div>
                        </div>

                        {/* Comment Content */}
                        <div className="p-1 flex-1">
                            <p className="font-semibold text-sm">
                                {c.name}{' '}
                                <span className="text-gray-500 text-xs ml-1">{getRelativeTime(c.createdAt)}</span>
                            </p>
                            <p className="text-sm text-gray-700">{c.comment}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
